import { useSetAtom } from "jotai";
import { API_UPDATE_NAME } from "../constants/api";
import { NameResult } from "../types";
import { useFetch } from "./useFetch";
import { nameResultsAtom } from "../store/store";
import ToastService from "../components/common/Toast/ToastService";

export const useSaveName = () => {
  const { request } = useFetch();
  const setResults = useSetAtom(nameResultsAtom);

  const handleSaveName = async (result: NameResult) => {
    const newStatus = result.status === 1 ? 0 : 1;
    try {
      await request(API_UPDATE_NAME, {
        method: "POST",
        body: {
          id: result.id,
          status: newStatus,
        },
      });
      // 更新结果列表中的状态
      setResults((prev) =>
        prev.map((item) =>
          item.id === result.id ? { ...item, status: newStatus } : item
        )
      );
      // 根据状态显示不同的提示信息
      if (newStatus === 1) {
        ToastService.success("Name saved successfully");
      } else {
        ToastService.success("Name unsaved");
      }
    } catch (error) {
      // 根据状态显示不同的提示信息
      if (newStatus === 1) {
        ToastService.error("Failed to save name");
      } else {
        ToastService.error("Failed to unsave name");
      }
    }
  };

  return { handleSaveName };
};
